import React from 'react';
import { Navigate, Route, Routes as RouteList } from 'react-router';
import Layout from '../components/layout/Layout';
import NewOrderPage from '../pages/order-flow/NewOrderPage';
import AuthGuard from './AuthGuard';
import LoginPage from '../pages/auth/LoginPage';
import OrderListPage from '../pages/order-dashboard/OrderListPage';
import OrderDetailsPage from '../pages/order-dashboard/subpages/OrderDetailsPage';
import StoreListPage from '../pages/stores/StoreListPage';
import OrderInfoPage from '../pages/order-flow/subpages/OrderInfoPage';
import OrderItemsPage from '../pages/order-flow/subpages/OrderItemsPage';
import OrderConfirmationPage from '../pages/order-flow/subpages/OrderConfirmationPage';
import StoreLoadedGuard from './StoreLoadedGuard';
import BlockedNumbersPage from '../pages/blocked-numbers/BlockedNumbersPage';

enum NewOrderRoutes {
  Root = 'new-order',
  OrderItems = 'items',
  OrderInfo = 'info',
  OrderConfirmation = 'confirmation',
}

export const Routes = {
  Login: 'login',

  NewOrder: NewOrderRoutes,

  Orders: 'orders',

  Restaurants: 'restaurants',

  BlockedNumbers: 'blocked-numbers',
};

export default function Router() {
  return (
    <RouteList>
      <Route path="/" element={<Navigate to={Routes.NewOrder.Root} replace />} />
      <Route path={Routes.Login} element={<LoginPage />} />

      <Route element={<AuthGuard />}>
        <Route element={<Layout />}>
          <Route path={Routes.NewOrder.Root}>
            <Route index element={<NewOrderPage />} />
            <Route element={<StoreLoadedGuard />}>
              <Route path={Routes.NewOrder.OrderItems} element={<OrderItemsPage />} />
              <Route path={Routes.NewOrder.OrderInfo} element={<OrderInfoPage />} />
              <Route path={Routes.NewOrder.OrderConfirmation} element={<OrderConfirmationPage />} />
            </Route>
          </Route>

          <Route path={Routes.Orders}>
            <Route index element={<OrderListPage />} />
            <Route path=":id" element={<OrderDetailsPage />} />
          </Route>
          <Route path={Routes.Restaurants} element={<StoreListPage />} />
          <Route path={Routes.BlockedNumbers} element={<BlockedNumbersPage />} />
        </Route>
      </Route>
    </RouteList>
  );
}
